/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Alert from "@mui/material/Alert";
import { useNitroStore } from "../../../store/Store";
import Debounce from "../../../utils/Debounce";

const currentFieldDebounce = new Debounce(100);

const Notifications = () => {
  const [
    storageFacilityCityWarning,
    setStorageFacilityCityWarning,
    storageFacilityStateWarning,
    setStorageFacilityStateWarning,
    setShowAddLocationPanel,
    setActiveFilter,
  ] = useNitroStore((state) => [
    state.storageFacilityCityWarning,
    state.setStorageFacilityCityWarning,
    state.storageFacilityStateWarning,
    state.setStorageFacilityStateWarning,
    state.setShowAddLocationPanel,
    state.setActiveFilter,
  ]);

  return (
    <div
      id="Notifications"
      style={{
        position: "fixed",
        top: 122,
        left: 0,
        right: 0,
        display: "flex",
        zIndex: 3000,
        justifyContent: "center",
      }}
    >
      {storageFacilityCityWarning && (
        <Alert
          severity="error"
          onClose={() => setStorageFacilityCityWarning(false)}
        >
          This company has no storage locations in this city. To add a storage
          facility or do competitive analysis select a grey pin.
        </Alert>
      )}

      {storageFacilityStateWarning && (
        <Alert
          severity="error"
          onClose={() => setStorageFacilityStateWarning(false)}
        >
          This company has no storage locations in this state. Add a{" "}
          <span
            style={{
              fontWeight: 600,
              color: "#005CA6",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowAddLocationPanel(true);
            }}
          >
            STORAGE FACILITY
          </span>{" "}
          or to do competitive analysis
          {/* search a City using the WHERE filter above */}{" "}
          <span
            style={{
              fontWeight: 600,
              color: "#005CA6",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              // setActiveFilter("location");
              currentFieldDebounce.call(() => setActiveFilter("location"));
            }}
          >
            SEARCH A CITY
          </span>{" "}
          .
        </Alert>
      )}
    </div>
  );
};

export default Notifications;
